import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { IUser } from '../interfaces/user.interface';

/**
 * De alleen-lezen rol voor sales (eigenaar 15-10-2026: Marc ziet "alleen
 * totalen + namen", "alleen-lezen: alleen cijferpagina").
 *
 * Deze guard is het gemak, niet de beveiliging: hij houdt de rol weg van
 * pagina's die hij niet hoort te zien. Dat de rol niets kán wijzigen moet de
 * API afdwingen; zie de PR.
 */
export const SALES_ROL = 'sales_viewer';

export function isSalesViewer(user: IUser | null | undefined): boolean {
  const rol: unknown = user?.role;
  return Array.isArray(rol) ? rol.includes(SALES_ROL) : rol === SALES_ROL;
}

/** Op elke pagina behalve Numbers: sales gaat terug naar Numbers. */
export const geenSalesGuard = (): boolean | UrlTree => {
  return isSalesViewer(inject(AuthService).user) ? inject(Router).createUrlTree(['/numbers']) : true;
};
